var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtueltoplevelsespunkt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#ef6545"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.108,6.134l-1.584-.6V5.259a.141.141,0,0,0-.1-.134L6.639,4.566a.277.277,0,0,0-.272-.239.28.28,0,0,0-.281.28v4.83a.281.281,0,1,0,.561,0V7.126l1.532-.48v.276a.141.141,0,0,0,.19.131L10.108,6.4a.141.141,0,0,0,0-.263Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1,1.971H5.739A1.131,1.131,0,0,0,4.61,3.1v9.391a1.13,1.13,0,0,0,1.129,1.128H10.1a1.128,1.128,0,0,0,1.127-1.128V3.1A1.129,1.129,0,0,0,10.1,1.971Zm.7,10.52a.7.7,0,0,1-.7.7H5.739a.7.7,0,0,1-.7-.7V11.382H10.8Zm0-1.54H5.041V3.1a.7.7,0,0,1,.7-.7H10.1a.7.7,0,0,1,.7.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3,12.486H8.536a.216.216,0,0,0,0-.431H7.3a.216.216,0,0,0,0,.431Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtueltoplevelsespunkt);
export default __webpack_public_path__ + "static/media/VIRTUELT OPLEVELSESPUNKT.1df7eb558dc9a9f47a727bf701f2ffbc.svg";
export { ForwardRef as ReactComponent };